import { Observable } from 'rxjs';
import {
  ApiService,
  GET_TROPHIES_PER_USER_PATH,
  GET_USER_PROFILE_PATH,
  GetTrophiesPerUserPathParams,
  GetTrophiesPerUserResponse,
  GetUserProfilePathParams,
  GetUserProfileResponse,
  SET_MY_LANGUAGE_PATH,
  SetMyLanguageBody,
  SetMyLanguageResponse,
  UPDATE_MY_USER_PATH,
  UPDATE_USER_LOCATION_PATH,
  UpdateMyUserBody,
  UpdateMyUserResponse,
  UpdateUserLocationBody,
  UpdateUserLocationResponse
} from '@core-http';

export class UserService extends ApiService {
  getDetails(pathParams: GetUserProfilePathParams): Observable<GetUserProfileResponse> {
    const path: string = this.fillPathParams(GET_USER_PROFILE_PATH, pathParams);

    return this.httpClient.get<GetUserProfileResponse>(`${this.env.apiUrl}${path}`);
  }

  updateUser(payload: UpdateMyUserBody): Observable<UpdateMyUserResponse> {
    return this.httpClient.patch<UpdateMyUserResponse>(`${this.env.apiUrl}${UPDATE_MY_USER_PATH}`, payload);
  }

  getUserTrophies(pathParams: GetTrophiesPerUserPathParams): Observable<GetTrophiesPerUserResponse> {
    const path: string = this.fillPathParams(GET_TROPHIES_PER_USER_PATH, pathParams);

    return this.httpClient.get<GetTrophiesPerUserResponse>(`${this.env.apiUrl}${path}`);
  }

  setLanguage(payload: SetMyLanguageBody): Observable<SetMyLanguageResponse> {
    return this.httpClient.patch<SetMyLanguageResponse>(`${this.env.apiUrl}${SET_MY_LANGUAGE_PATH}`, payload);
  }

  updateLocation(payload: UpdateUserLocationBody): Observable<UpdateUserLocationResponse> {
    return this.httpClient.put<UpdateUserLocationResponse>(`${this.env.apiUrl}${UPDATE_USER_LOCATION_PATH}`, payload);
  }
}
